import parse from 'html-react-parser';
import escapeRegExp from 'escape-string-regexp';

export const markedLabel = (label: string, escapedFilter: string) => {
  const regex = /(<([^>]+)>)/gi;
  return parse(
    label
      .replace(regex, '')
      .replace(new RegExp(`(${escapeRegExp(escapedFilter)})`, 'gi'), '<b>$1</b>'),
  );
};

export const removeTags = (html: string) => html.replace(/<[^>]*>/g, '');
